module.exports = __webpack_public_path__ + "static/media/29FUNOV7.d08c8a05.jpg";